<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    <br>
    车公庙站<br>
站点介绍<br>
车公庙站位于深南大道与香蜜湖立交桥交叉口西侧，属地下三层站，1号线、7号线、9号线、11号线于香蜜湖立交桥西南角形成综合换乘体。1号线与11号线平行布置，通过站厅换乘，1/11号线与7/9号线车站呈“¬”型布置，通过换乘大厅换乘。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:02	23:47	1号线	2分钟	4分40秒<br>
机场东	06:41	23:21	1号线	2分钟	4分40秒<br>
西丽湖	06:36	23:35	7号线	3分35秒	5分55秒<br>
太安	06:00	23:21	7号线	3分35秒	5分55秒<br>
前湾	06:03	23:37	9号线	3分50秒	5分55秒<br>
文锦	06:23	23:33	9号线	3分50秒	5分55秒<br>
岗厦北	06:24	00:32	11号线	4分钟	6分32秒<br>
碧头	06:26	23:36	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:08	23:45	1号线	3分45秒	5分45秒<br>
机场东	06:41	23:21	1号线	3分45秒	5分45秒<br>
西丽湖	06:30	23:35	7号线	4分钟	5分55秒<br>
太安	06:06	23:21	7号线	4分钟	5分55秒<br>
前湾	06:03	23:37	9号线	4分25秒	5分55秒<br>
文锦	06:23	23:32	9号线	4分25秒	5分55秒<br>
岗厦北	06:24	00:32	11号线	4分34秒	6分钟<br>
碧头	06:26	23:36	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:08	00:45	1号线	3分45秒	5分45秒<br>
机场东	06:41	00:21	1号线	3分45秒	5分45秒<br>
西丽湖	06:30	00:35	7号线	4分钟	5分55秒<br>
太安	06:06	00:21	7号线	4分钟	5分55秒<br>
前湾	06:05	00:37	9号线	4分钟	5分55秒<br>
文锦	06:22	00:32	9号线	4分钟	5分55秒<br>
岗厦北	06:24	00:32	11号线	4分37秒	6分钟<br>
碧头	06:26	23:36	11号线	4分37秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南大道北侧、香蜜湖路、万科富春东方大厦、财富广场、东海花园二期、香荔绿洲<br><br>
B出入口:<br>
深南大道北侧、农园路、香林路、深圳工商物价大厦、深圳市市场和质量监督委员会、时代科技大厦、东海文化广场、招商银行大厦、阳光高尔夫大厦、香珠花园、香轩路、深圳市高级中学初中部、福田人民医院香蜜湖分院、东海国际中心、东海花园<br><br>
C出入口:<br>
深南大道南侧、泰然九路、创建大厦、大庆大厦、广安商贸大厦、金润大厦、金运世纪大厦、英龙大厦、世纪豪庭、皇冠体育中心、苍松大厦、海松大厦、泰安轩、泰康轩、泰然公寓区<br><br>
D1出入口:<br>
深南大道南侧、香蜜湖路、本元大厦、中国有色大厦<br><br>
D2出入口:<br>
深南大道南侧、香蜜湖路、本元大厦、中国有色大厦 、泰然二路、泰然公寓区、都市阳光名苑<br><br>
F出入口:<br>
香蜜湖路西侧、泰然四路、泰然六路、泰然文化广场、苍松大厦<br><br>
J1出入口:<br>
深南大道南侧、香蜜湖路东侧、中联大厦、安徽大厦创展中心、NEO大厦、劲松大厦、泰然工贸园、创新科技广场<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 招商银行大厦①<br>
高快巴士18，高快巴士31,101,303，M391，M392，M559,101,303，M391,M392，M559<br><br>
C出入口:<br>
公交站名： 招商银行大厦①<br>
324,326,338，M413，M435，M448，M165，高快巴士60号，N4，204,223，213,113,123,222，N6，高峰线119号，高峰专线62号，21,79,113<br><br>
J1出入口:<br>
公交站名： 深南香蜜立交①<br>
311,320,324,326,327,328,338,373,383,395，K318，M372，M391，M392,M413，M414,M435，M447，高峰专线123号，高峰专线15号，高峰专线18号，高快巴士13号，机场快线9号<br><br>
J1出入口:<br>
公交站名： 深南香蜜立交②<br>
21,32,54,79,101,113,123,204,209,213,215,222,223，N4，N6，高峰线119号，高峰专线49号，高峰专线62号<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jiuhaoxian",
          title: "9号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiyihaoxian",
          title: "11号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>







